__turbopack_context__.v({
  "h2Lg": "styleConstants-module__cBBLda__h2Lg",
  "p": "styleConstants-module__cBBLda__p",
  "pLg": "styleConstants-module__cBBLda__pLg",
  "primaryButton": "styleConstants-module__cBBLda__primaryButton",
  "primaryLink": "styleConstants-module__cBBLda__primaryLink",
});
